export const MORE_MENU_TYPES = {
  MY_PROFILE: 1,
  NOTIFICATION: 2,
  CHANGE_PASSWORD: 3,
  CONTACT_US: 4,
  ABOUT_THE_APP: 5,
  PRIVACY_POLICY: 6,
  LOGOUT: 7,
  RETAILER_REGISTRATION: 8,
  SEND_FEEDBACK: 9,
}

export const HeaderTypes = {
  DASHBOARD: 1,
  TODAY: 2,
  CALENDAR: 3,
  KRISHAK: 4,
  REPORTS: 5
}

export const ActivityType = {
  INDIVIDUAL_VISIT: 1,
  SAMPLE_DISTRIBUTION: 2,
  GROUP_MEETING: 3,
  SAMPLE_TO_SALE: 4,
}

export const HomeActivityType = {
  INDIVIDUAL_VISIT_FARMER: "Individual Visit - Farmer",
  INDIVIDUAL_VISIT_RETAILER: "Individual Visit - Retailer",
  SAMPLE_DISTRIBUTION: "Sample Distribution",
  GROUP_MEET: "Group Meeting",
  SAMPLE_TO_SALE: "Sample To Sale"
}

export const ActivityStatus = {
  TO_START: "To Start",
  IN_PROGRESS: "In Progress",
  PENDING_REVIEW: "Pending Review",
  TO_RESUBMIT: "To Resubmit",
  COMPLETED: "Completed",
}


export const ActivityStatusType = {
  TO_START: 1,
  IN_PROGRESS: 2,
  PENDING_REVIEW: 3,
  TO_RESUBMIT: 4,
  COMPLETED: 5,
}

export const DashboardType = {
  ACTIVITIES: 1,
  USERS: 2,
  TEHSILS: 3,
  HYBRID: 4,
}

export const RangeType = {
  LAST_MONTH: 1,
  LAST_QUARTER: 2,
  LAST_YEAR: 3,
  CUSTOM_RANGE: 4,
}

export const S2S_CROP = {
  COTTON: "Cotton",
  RICE: "Rice",
  MILLET: "Millets",
  MUSTARD: "Mustard",
}

export const S2S_STAGE = {
  SOWING_AND_TRANSPLANTATION: 1,
  SOWING: 1,
  TRANSPLANTATION: 2,
  PLOT_VISIT: 3,
  FIELD_DAY: 4,
  HARVEST_DETAILS: 5,
  FIELD_DAMAGE: 6,
  GERMINATION: 8,
  FRUIT_QUALITY: 9,
  PEST_AND_DISEASE: 10,
}


export const CROP_GROUP = {
  FIELD_CROPS: 1,
  VEGETABLE_CROPS: 3,
}


export const DakshModuleType = {
  SALE: 1,
  PLAN: 2
}

export const DakshSaleType = {
  NONE: 0,
  SEEDWORKS_SALE: 1,
  COMPETITOR_SALE: 2
}

export const DakshStatus = {
  TO_START: 1,
  PENDING: 2,
  COMPLETED: 3
}


export const ReportType = {
  EXPORT_KRISHAK_REPORT: 'exportKrishakReport',
  EXPORT_ACTIVITY_REPORT_IV: 'exportActivityReport_IV',
  EXPORT_ACTIVITY_REPORT_SD: 'exportActivityReport_SD',
  EXPORT_ACTIVITY_REPORT_GM: 'exportActivityReport_GM',
  EXPORT_ACTIVITY_REPORT_STS: 'exportActivityReport_STS',

}


